import axios from 'axios'
import _ from 'underscore'
import router from '../router'

axios.defaults.withCredentials = true

export default {
    state : { 
        baseUrl:process.env.API_URL,
        reminders:[],
        notificationTab:'reminder',
        notifications:[]
    },
    getters : {
        reminders:(state)=>{
            return state.reminders
        },
        notifications:(state)=>{
            return state.notifications
        },
        notificationTab:(state)=>{
            return state.notificationTab
        }
    },
    mutations : { 
        reminders(state,reminders){
            state.reminders = reminders
        },
        notifications(state,notifications){
            state.notifications = notifications
        },
        notificationTab(state,data){
            state.notificationTab = data
        }
    },
    actions : { 
        upsertReminder({state,commit},form){

            return new Promise((resolve, reject) => {
                axios.post(`${state.baseUrl}/upsertReminder`,form)
                .then(response => {
                    console.log("upsertReminder action response")
                    console.log(response)
                    if(response.data.status.code==0){
                        
                        //commit('reminders',response.data.content.reminders)

                        resolve(response.data)
                        
                    }else{
                        resolve(response.data)
                    }
                })
                .catch(e => {
                    console.log(e.message)
                    reject()
                })
            })
            
        },
        getReminders({state,commit},form){
            return new Promise((resolve, reject) => {
                axios.post(`${state.baseUrl}/getReminders`,form)
                .then(response => {
                    if(response.data.status.code==0){
                        if(_.isEmpty(form)){
                            commit('reminders',response.data.content.reminders)
                            commit('user',response.data.user)
                            commit('users',response.data.users) 
                        }
                        resolve(response.data)
                        
                    }else{
                        resolve(response.data)
                    }
                })
                .catch(e => {
                    console.log(e.message)
                    reject()
                })
            })
            
        },
        setNotificationTab({commit},data){
            commit("notificationTab",data)
        },
        getNotifications({state,commit},form){
            return new Promise((resolve, reject) => {
                axios.post(`${state.baseUrl}/getNotifications`,form)
                .then(response => {
                    
                    if(response.data.status.code==0){
                        if(_.isEmpty(form)){
                            commit('notifications',response.data.content.notifications)
                            commit('user',response.data.user)
                            commit('users',response.data.users) 
                        }
                        resolve(response.data)
                        
                    }
                    else if(response.data.status.code==2054){
                        router.push({ path: 'settings',  query: { paymentStatus: 'userManagement' } })
                    }
                    else if(response.data.status.code==2001){
                        console.log("2001")
                        router.push({ path: 'logout' })
                    }
                    else{
                        resolve(response.data)
                    }
                })
                .catch(e => {
                    console.log(e.message)
                    reject()
                })
            })
            
        },
        updateNotification({state},form){
            return new Promise((resolve, reject) => {
                axios.post(`${state.baseUrl}/updateNotification`,form)
                .then(response => {
                    console.log("updateNotification action response")
                    console.log(response)
                    if(response.data.status.code==0){
                        
                        resolve(response.data)
                        
                    }else{
                        resolve(response.data)
                    }
                })
                .catch(e => {
                    console.log(e.message)
                    reject()
                })
            })
            
        },
    }
}